module.exports = __webpack_public_path__ + "static/media/bg_personal_characteristics.127dbc30.mp4";